module.exports = __webpack_public_path__ + "static/media/resource5.61a659cf.svg";